<template>
  <div>
    <highcharts
      :options="chartOptions" />
  </div>
</template>

<script>
import {Chart} from 'highcharts-vue'

export default {
  name: 'Columns',
  components: {
    highcharts: Chart
  },
  props: {
    dataChart: {
      type: Object
    },
    disableExpandDetails: {
      type: Boolean
    }
  },
  data () {
    return {
    }
  },
  computed: {
    valueType () {
      return {
        'days': ' dias',
        'percent': '%',
        'number': ''
      }[this.dataChart.value_type]
    },
    chartOptions () {
      const _self = this
      return {
        chart: {
          type: 'column',
          height: 320,
          scrollablePlotArea: {
            minWidth: this.dataChart.series.length * 30 // 400
          },
          events: this.disableExpandDetails ? null : {
            click: function (event) {
              const point = this.series[0].searchPoint(event, true)
              _self.expand(point.index)
            }
          },
          style: this.disableExpandDetails ? null : {
            cursor: 'pointer'
          }
        },
        title: {
          text: null
        },
        xAxis: {
          crosshair: true,
          categories: this.dataChart.categories /* ['Apples', 'Oranges', 'Pears', 'Grapes', 'Bananas'] */
        },
        yAxis: {
          min: 0,
          title: {
            text: this.dataChart.metric_name
          },
          stackLabels: {
            enabled: true
          }
        },
        tooltip: {
          // pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
          shared: true,
          valueSuffix: this.valueType
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          },
          series: this.disableExpandDetails ? null : {
            cursor: 'pointer',
            point: {
              events: {
                click: (a) => {
                  this.expand(a.point.index)
                }
              }
            }
          }
        },
        legend: {
          // align: "right",
          enabled: true,
          layout: 'horizontal',
          maxHeight: 70
          // margin: 10,
          // useHTML: true,
          // verticalAlign: 'top',
          // x: 0,
          // y: 100
        },
        series: this.dataChart.series /* [{
            name: 'John',
            data: [5, 3, 4, 7, 2]
        }, {
            name: 'Jane',
            data: [2, 2, 3, 2, 1]
        }, {
            name: 'Joe',
            data: [3, 4, 4, 2, 5]
        }] */
      }
    }
  },
  created () {
  },
  methods: {
    expand (index) {
      const filters = this.dataChart.filters[index]
      const name = this.dataChart.categories[index]
      this.$emit('expand', { filters, name })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ReportChart/ColumnsWithSegments.vue